import apiClient from "./apiClient";

// Use relative path so apiClient can add baseURL and organizationId
const API_URL = `/kardex/medical-history`;

export const create = async (historyData) => {
  // apiClient will automatically add organizationId via interceptor
  const response = await apiClient.post(`${API_URL}/create-history`, historyData);
  return response.data;
};

export const getHistoryByPatientAndAdmission = async (patientId, admissionId) => {
  try {
    // apiClient will automatically add organizationId as query param via interceptor
    const response = await apiClient.get(
      `${API_URL}/by-patient-admission/${patientId}/${admissionId}`
    );
    return response.data;
  } catch (error) {
    // If organization-specific kardex table doesn't exist, return empty array
    if (
      error.response?.status === 500 &&
      (error.response?.data?.message?.includes("Failed to retrieve") ||
        error.response?.data?.message?.includes("from table") ||
        error.response?.data?.message?.includes("does not exist"))
    ) {
      return [];
    }
    throw error;
  }
};

export default {
  create,
  getHistoryByPatientAndAdmission,
};